import { Link } from 'react-router'
import { useAuth } from '@/auth/AuthProvider'
import { useMyPools } from './queries'

export default function PoolPickerPage() {
  const { profile, signOut } = useAuth()
  const { data: pools, isPending, isError } = useMyPools()

  return (
    <main className="bg-stock min-h-dvh">
      <div className="mx-auto max-w-md px-6 py-14">
        <p className="eyebrow mb-3">
          {profile?.display_name ? `Welcome back, ${profile.display_name}` : 'Welcome back'}
        </p>
        <h1 className="font-display text-ink mb-10 text-[2.25rem] leading-[0.95]">
          YOUR POOLS
        </h1>

        {isPending && <p className="eyebrow">Loading…</p>}

        {isError && (
          <p role="alert" className="border-flag text-flag border-l-2 pl-3 text-body">
            Your pools didn't load. Pull down to try again.
          </p>
        )}

        {pools?.length === 0 && (
          <div className="border-rule rounded-row border border-dashed px-5 py-8">
            <p className="text-ink text-body">
              You're signed in but not in a pool yet. Ask whoever invited you to add you, and
              this page fills in.
            </p>
          </div>
        )}

        <ul className="flex flex-col gap-3">
          {pools?.map((pool) => (
            <li key={pool.id}>
              <Link
                to={`/p/${pool.slug}/picks`}
                className="bg-card border-rule rounded-row hover:border-field flex items-center justify-between border px-5 py-4 transition-colors"
              >
                <span className="text-ink text-team font-semibold">{pool.name}</span>
                <span className="eyebrow">Open</span>
              </Link>
            </li>
          ))}
        </ul>

        <button
          type="button"
          onClick={() => void signOut()}
          className="text-ink-dim hover:text-ink mt-12 text-body underline underline-offset-4"
        >
          Sign out
        </button>
      </div>
    </main>
  )
}
